import { FinalStatus } from 'modules/individuals/enums/Status'

enum  InformationCarrierPatrenal {
    A = "There are not enough key possitions for a conclusive paternal inheritance identification. Manual review is mandatory.",
    B = "There are not enough key possitions for a conclusive paternal inheritance identification. Manual review is highly recommended.",
    C = "On one side of the variant, there are not enough key positions for paternal carrier allele. Direct testing is not viable. Manual review is recommended.",
    D = "On one side of the variant, there are not enough key positions for paternal non-carrier allele. Direct testing is viable. Manual review is recommended",
    E = "On one side of the variant, there are not enough key positions for paternal carrier allele. Direct testing is viable. Manual review is recommended.",
    F = "On both sides of the variant, there are not enough key positions for one of the paternal alleles while there are more than 6 positions for the other paternal allele. Direct testing is not viable. Manual review is recommended.",
    G = "On one side of the variant, there are not enough key positions for the paternal non-carrier allele while there are more than 6 positions for the paternal carrier allele. Direct testing is not viable. Manual review is recommended. ",
    H = "There are not enough key positions for paternal carrier allele while there are more then 6 positions on each side of the variant for the paternal non-carrier allele. This allows the correct identification of non-carrier embryos. Direct testing is not viable. Manual review is recommended. ",
    I = "There are not enough key positions for paternal non-carrier allele while there are more then 6 positions on each side of the variant for the paternal carrier allele. Direct testing is viable. Manual review is recommended. ",
    J = "On both sides of the variant, there are not enough key positions for one of the paternal alleles while there are more than 6 positions for the other paternal allele. Direct testing is viable. Manual review is recommended.",
    K = "There are not enough key positions for paternal carrier allele while there are more then 6 positions on each side of the variant for the paternal non-carrier allele. This allows the correct identification of non-carrier embryos. Direct testing is viable. Manual review is recommended. ",
    L = "On one side of the variant, there are not enough key positions for both paternal alleles. Direct testing is viable. Manual review is recommended. ",
    M = "There are enough key positions for both paternal alleles on both sides of the variant. Direct testing is not viable. ",
    N = "There are enough key positions for both paternal alleles on both sides of the variant. Direct testing is viable. ",
    O = "On one side of the variant, there are not enough key positions for the paternal carrier allele while there are more than 6 positions for the paternal non-carrier allele. This allows the correct identification of non-carrier embryos. Direct testing is viable. ",
    P = "There are not enough key positions for paternal carrier allele while there are enough key positions on each side of the variant for the paternal non-carrier allele. This allows the correct identification of non-carrier embryos. Direct testing is viable. Manual review is recommended. ",
}

enum  InformationCarrierMaternal {
    A = "There are not enough key possitions for a conclusive maternal inheritance identification. Manual review is mandatory.",
    B = "There are not enough key possitions for a conclusive maternal inheritance identification. Manual review is highly recommended.",
    C = "On one side of the variant, there are not enough key positions for maternal carrier allele. Direct testing is not viable. Manual review is recommended.",
    D = "On one side of the variant, there are not enough key positions for maternal non-carrier allele. Direct testing is viable. Manual review is recommended",
    E = "On one side of the variant, there are not enough key positions for maternal carrier allele. Direct testing is viable. Manual review is recommended.",
    F = "On both sides of the variant, there are not enough key positions for one of the maternal alleles while there are more than 6 positions for the other maternal allele. Direct testing is not viable. Manual review is recommended.",
    G = "On one side of the variant, there are not enough key positions for the maternal non-carrier allele while there are more than 6 positions for the maternal carrier allele. Direct testing is not viable. Manual review is recommended. ",
    H = "There are not enough key positions for maternal carrier allele while there are more then 6 positions on each side of the variant for the maternal non-carrier allele. This allows the correct identification of non-carrier embryos. Direct testing is not viable. Manual review is recommended. ",
    I = "There are not enough key positions for maternal non-carrier allele while there are more then 6 positions on each side of the variant for the maternal carrier allele. Direct testing is viable. Manual review is recommended. ",
    J = "On both sides of the variant, there are not enough key positions for one of the maternal alleles while there are more than 6 positions for the other maternal allele. Direct testing is viable. Manual review is recommended.",
    K = "There are not enough key positions for maternal carrier allele while there are more then 6 positions on each side of the variant for the maternal non-carrier allele. This allows the correct identification of non-carrier embryos. Direct testing is viable. Manual review is recommended. ",
    L = "On one side of the variant, there are not enough key positions for both maternal alleles. Direct testing is viable. Manual review is recommended. ",
    M = "There are enough key positions for both maternal alleles on both sides of the variant. Direct testing is not viable. ",
    N = "There are enough key positions for both maternal alleles on both sides of the variant. Direct testing is viable. ",
    O = "On one side of the variant, there are not enough key positions for the maternal carrier allele while there are more than 6 positions for the maternal non-carrier allele. This allows the correct identification of non-carrier embryos. Direct testing is viable. ",
    P = "There are not enough key positions for maternal carrier allele while there are enough key positions on each side of the variant for the maternal non-carrier allele. This allows the correct identification of non-carrier embryos. Direct testing is viable. Manual review is recommended. ",
}


enum InformationAffectedPaternal {
    A = "There are not enough key possitions for a conclusive paternal inheritance identification. Manual review is mandatory. ",
    B = "On both sides of the variant, there are not enough key positions for one of the paternal alleles while there are enough key positions for the other paternal allele. Direct testing is not viable. Manual review is recommended.",
    C = "On one side of the variant, there are not enough key positions for the paternal carrier 1 allele. Direct testing for this variant is not viable. Manual review is recommended.",
    D = "On one side of the variant, there are not enough key positions for the paternal carrier 2 allele. Direct testing for this variant is not viable. Manual review is recommended.",
    E = "On one side of the variant, there are not enough key positions for the paternal carrier 1 allele. Direct testing for this variant is viable. ",
    F = "On one side of the variant, there are not enough key positions for the paternal carrier 2 allele. Direct testing for this variant is viable. ",
    G = "There are enough key positions for both paternal alleles on both sides of the variant. Direct testing is not viable. ",
    H = "There are not enough key possitions for a conclusive paternal inheritance identification. Manual review is highly recommended.",
    I = "On both sides of the variant, there are not enough key positions for one of the paternal alleles while there are enough key positions for the other paternal allele. Direct testing for one of the variants is viable. Manual review is recommended.",
    J = "On both sides of the variant, there are not enough key positions for one of the paternal alleles while there are enough key positions for the other paternal allele. Direct testing for both variants is viable. Manual review is recommended.",
    K = "There are enough key positions for both paternal alleles on both sides of the variant. Direct testing for one variant is viable. ",
    L = "There are enough key positions for both paternal alleles on both sides of the variant. Direct testing for both variants is viable. ",
    M = "On both sides of the variant, there are not enough key positions for the paternal carrier 2 allele. Direct testing for this variant is viable. Manual review is recommended.",
    N = "On both sides of the variant, there are not enough key positions for the paternal carrier 1 allele. Direct testing for this variant is viable. Manual review is recommended.",
    O = "On one side of the variant, there are not enough key positions for both paternal carrier alleles. Direct testing for one variant is viable. Manual review is recommended. ",
    P = "On one side of the variant, there are not enough key positions for both paternal carrier alleles. Direct testing for both variants is viable. Manual review is recommended. ",
}

enum InformationAffectedMaternal {
    A = "There are not enough key possitions for a conclusive maternal inheritance identification. Manual review is mandatory. ",
    B = "On both sides of the variant, there are not enough key positions for one of the maternal alleles while there are enough key positions for the other maternal allele. Direct testing is not viable. Manual review is recommended.",
    C = "On one side of the variant, there are not enough key positions for the maternal carrier 1 allele. Direct testing for this variant is not viable. Manual review is recommended.",
    D = "On one side of the variant, there are not enough key positions for the maternal carrier 2 allele. Direct testing for this variant is not viable. Manual review is recommended.",
    E = "On one side of the variant, there are not enough key positions for the maternal carrier 1 allele. Direct testing for this variant is viable. ",
    F = "On one side of the variant, there are not enough key positions for the maternal carrier 2 allele. Direct testing for this variant is viable. ",
    G = "There are enough key positions for both maternal alleles on both sides of the variant. Direct testing is not viable. ",
    H = "There are not enough key possitions for a conclusive maternal inheritance identification. Manual review is highly recommended.",
    I = "On both sides of the variant, there are not enough key positions for one of the maternal alleles while there are enough key positions for the other maternal allele. Direct testing for one of the variants is viable. Manual review is recommended.",
    J = "On both sides of the variant, there are not enough key positions for one of the maternal alleles while there are enough key positions for the other maternal allele. Direct testing for both variants is viable. Manual review is recommended.",
    K = "There are enough key positions for both maternal alleles on both sides of the variant. Direct testing for one variant is viable. ",
    L = "There are enough key positions for both maternal alleles on both sides of the variant. Direct testing for both variants is viable. ",
    M = "On both sides of the variant, there are not enough key positions for the maternal carrier 2 allele. Direct testing for this variant is viable. Manual review is recommended.",
    N = "On both sides of the variant, there are not enough key positions for the maternal carrier 1 allele. Direct testing for this variant is viable. Manual review is recommended.",
    O = "On one side of the variant, there are not enough key positions for both maternal carrier alleles. Direct testing for one variant is viable. Manual review is recommended. ",
    P = "On one side of the variant, there are not enough key positions for both maternal carrier alleles. Direct testing for both variants is viable. Manual review is recommended. ",
}

enum InformationEmbryosPaternal {
    A = "There are not enough key positions for a conclusive paternal inheritance identification. Manual review is mandatory. ",
    B = "There are not enough key positions for a conclusive paternal inheritance identification. Manual review is highly recommended. ",
    C = "On one side of the variant, there are not enough key positions for paternal allele. Direct testing is not viable. Manual review is recommended.",
    D = "On one side of the variant, there are not enough key positions for paternal allele, however there are enough informative positions on that side. Direct testing is not viable. Manual review is recommended.",
    E = "On one side of the variant, there are not enough key positions for paternal  allele. Direct testing is viable. Manual review is recommended.",
    F = "On one side of the variant, there are not enough key positions for paternal allele, however there are enough informative positions on that side. Direct testing is viable. Manual review is recommended.",
    G = "There are enough key positions for  paternal allele on both sides of the variant. Direct testing is not viable. ",
    H = "There are enough key positions for  paternal allele on both sides of the variant. Direct testing is viable. ",
    I = "There are not enough key positions for paternal allele, however there are enough informative positions on both sides. Direct testing is viable. Manual review is recommended. ",
    J = "There are not enough key positions for a conclusive paternal inheritance identification. Direct testing is viable. Manual review is highly recommended. " 

}

enum InformationEmbryosMaternal {
    A = "There are not enough key positions for a conclusive Maternal inheritance identification. Manual review is mandatory. ",
    B = "There are not enough key positions for a conclusive Maternal inheritance identification. Manual review is highly recommended. ",
    C = "On one side of the variant, there are not enough key positions for Maternal allele. Direct testing is not viable. Manual review is recommended.",
    D = "On one side of the variant, there are not enough key positions for Maternal allele, however there are enough informative positions on that side. Direct testing is not viable. Manual review is recommended.",
    E = "On one side of the variant, there are not enough key positions for Maternal  allele. Direct testing is viable. Manual review is recommended.",
    F = "On one side of the variant, there are not enough key positions for Maternal allele, however there are enough informative positions on that side. Direct testing is viable. Manual review is recommended.",
    G = "There are enough key positions for  Maternal allele on both sides of the variant. Direct testing is not viable. ",
    H = "There are enough key positions for  Maternal allele on both sides of the variant. Direct testing is viable. ",
    I = "There are not enough key positions for Maternal allele, however there are enough informative positions on both sides. Direct testing is viable. Manual review is recommended. ",
    J = "There are not enough key positions for a conclusive Maternal inheritance identification. Direct testing is viable. Manual review is highly recommended. " 

}




export function confidenceLevel(   
    aboveGeneA1: number,
    belowGeneA1: number,
    aboveGeneA2: number,
    belowGeneA2: number,
    directDetection: boolean,
    finalStatus: FinalStatus,
    parents: string,
    directDetection2?: boolean | null
){

    let allele1Up:  boolean = false
    let allele1Down:  boolean = false
    let allele2Up:  boolean = false
    let allele2Down:  boolean = false
    let confidenceNumber: number = 0
    let information: string = ''

    const calculatedCarrier = () => {
        let upNonCarAux: number  = 0
        let downNonCarAux: number = 0
        let upCarAux: number = 0
        let downCarAux: number = 0
        if (finalStatus === FinalStatus.CarrierFromMother){

            upNonCarAux = aboveGeneA2
            downNonCarAux = belowGeneA2
            upCarAux = aboveGeneA1
            downCarAux = belowGeneA1

            allele1Up = upNonCarAux >= 3
            allele1Down = downNonCarAux>= 3
            allele2Up = upCarAux >= 3
            allele2Down = downCarAux >= 3

        } else if (finalStatus === FinalStatus.CarrierFromFather){
            upNonCarAux = aboveGeneA1
            downNonCarAux = belowGeneA1
            upCarAux = aboveGeneA2
            downCarAux = belowGeneA2


            allele1Up = upNonCarAux >= 3
            allele1Down = downNonCarAux>= 3
            allele2Up = upCarAux >= 3
            allele2Down = downCarAux >= 3
        }

        /*
            arbol de condicionales proporcionado por aurora para el nivel de confianza con un alelo sano
        */
    // el alelo sano contiene 3 o mas kp arriba o abajo de la variante    
        if(allele1Up || allele1Down){
            if (allele1Up && allele1Down) {
                if (allele2Up && allele2Down) {
                    if (directDetection){
                        information = parents === "maternal"? InformationCarrierMaternal.N : InformationCarrierPatrenal.N
                        return 8
                    }else {
                        information = parents === "maternal"? InformationCarrierMaternal.M : InformationCarrierPatrenal.M
                        return 7
                }   
                } else  {
                    if (allele2Up|| allele2Down){
                        if (directDetection){
                            if ((allele2Up && downNonCarAux >= 6 && downCarAux !== 0) ||
                               ( allele2Down && upNonCarAux >= 6 && upCarAux !== 0)){
                                information = parents === "maternal"? InformationCarrierMaternal.O : InformationCarrierPatrenal.O
                                return 7
                            } else {
                                information = parents === "maternal"? InformationCarrierMaternal.E : InformationCarrierPatrenal.E
                                return 6
                            }
                        }else {
                            information = parents === "maternal"? InformationCarrierMaternal.C : InformationCarrierPatrenal.C
                            return 5
                        }   
                    } else {
                        if (directDetection){
                            if(upNonCarAux >= 6 && downNonCarAux >= 6 && upCarAux !== 0 && downCarAux !== 0 
                            ) {
                                information = parents === "maternal"? InformationCarrierMaternal.K : InformationCarrierPatrenal.K
                                return 7
                            } else {
                                information = parents === "maternal"? InformationCarrierMaternal.P : InformationCarrierPatrenal.P
                                return 5
                            }
                        }else {
                            if(upNonCarAux >= 6 && downNonCarAux >= 6 && upCarAux !== 0 && downCarAux !== 0 
                            ) {
                                information = parents === "maternal"? InformationCarrierMaternal.H: InformationCarrierPatrenal.H
                                return 6
                            } else {
                                information = parents === "maternal"? InformationCarrierMaternal.B: InformationCarrierPatrenal.B
                                return 4
                            }
                        }   
                    }
                }
            } else {
                if(allele1Up){
                    if (allele2Up && allele2Down) {
                        if (directDetection){
                            information = parents === "maternal"? InformationCarrierMaternal.D: InformationCarrierPatrenal.D
                            return 5
                        } else {
                            if (downNonCarAux !== 0 && downCarAux >= 6 ) {
                                information = parents === "maternal"? InformationCarrierMaternal.G: InformationCarrierPatrenal.G
                                return 5
                            }else {
                                information = parents === "maternal"? InformationCarrierMaternal.B: InformationCarrierPatrenal.B
                                return 4
                            }
                        }
                    } else {
                        if (allele2Up){
                           if (directDetection){
                                if (downNonCarAux !== 0 && downCarAux !== 0){
                                    information = parents === "maternal"? InformationCarrierMaternal.L: InformationCarrierPatrenal.L
                                    return 5
                                } else {
                                    information = parents === "maternal"? InformationCarrierMaternal.B: InformationCarrierPatrenal.B
                                    return 4
                                }
                           } else { 
                                information = parents === "maternal"? InformationCarrierMaternal.B: InformationCarrierPatrenal.B
                                return 3
                            }
                        } else if (allele2Down){
                            if (directDetection){
                                if (upNonCarAux >= 6 && downNonCarAux !== 0 && upCarAux !== 0 && downCarAux >= 6){
                                    information = parents === "maternal"? InformationCarrierMaternal.J: InformationCarrierPatrenal.J
                                    return 6
                                } else {
                                    information = parents === "maternal"? InformationCarrierMaternal.B: InformationCarrierPatrenal.B
                                    return 4
                                }
                            } else {
                                if( upNonCarAux >= 6 && downNonCarAux !== 0 && upCarAux !== 0 && downCarAux >=6){
                                    information = parents === "maternal"? InformationCarrierMaternal.F: InformationCarrierPatrenal.F
                                    return 5
                                } else {
                                    information = parents === "maternal"? InformationCarrierMaternal.B: InformationCarrierPatrenal.B
                                    return 3
                                }
                            }
                            
                        } else {
                            if (directDetection){
                                information = parents === "maternal"? InformationCarrierMaternal.B: InformationCarrierPatrenal.B
                                return 3
                            } else {
                                information = parents === "maternal"? InformationCarrierMaternal.A: InformationCarrierPatrenal.A
                                return 2
                            }
                        }
                    }
                } else if(allele1Down){
                    if (allele2Up && allele2Down) {
                        if (directDetection){
                            information = parents === "maternal"? InformationCarrierMaternal.D: InformationCarrierPatrenal.D
                            return 5
                        } else {
                            if (upNonCarAux !== 0 && upCarAux >= 6 ) {
                                information = parents === "maternal"? InformationCarrierMaternal.G: InformationCarrierPatrenal.G
                                return 5
                            }else {
                                information = parents === "maternal"? InformationCarrierMaternal.B: InformationCarrierPatrenal.B
                                return 4
                            }
                        }
                    } else {
                        if (allele2Up){
                           if (directDetection){
                                if (upNonCarAux !== 0 && downNonCarAux >= 6 && upCarAux >= 6 && downCarAux !== 0){
                                    information = parents === "maternal"? InformationCarrierMaternal.F: InformationCarrierPatrenal.F
                                    return 5
                                } else {
                                    information = parents === "maternal"? InformationCarrierMaternal.B: InformationCarrierPatrenal.B
                                    return 4
                                }
                           } else { 
                                if (upNonCarAux !== 0 && downNonCarAux >= 6 && upCarAux >= 6 && downCarAux !== 0){
                                    information = parents === "maternal"? InformationCarrierMaternal.F: InformationCarrierPatrenal.F
                                    return 5
                                } else {
                                    information = parents === "maternal"? InformationCarrierMaternal.B: InformationCarrierPatrenal.B
                                    return 3
                                }
                            }
                        } else if (allele2Down){
                            if (directDetection){
                                if (upNonCarAux !== 0 && upCarAux !== 0){
                                    information = parents === "maternal"? InformationCarrierMaternal.L: InformationCarrierPatrenal.L
                                    return 5
                                } else {
                                    information = parents === "maternal"? InformationCarrierMaternal.B: InformationCarrierPatrenal.B
                                    return 4
                                }
                            } else {
                                information = parents === "maternal"? InformationCarrierMaternal.B: InformationCarrierPatrenal.B
                                return 3
                            }
                            
                        } else {
                            if (directDetection){
                                information = parents === "maternal"? InformationCarrierMaternal.B: InformationCarrierPatrenal.B
                                return 3
                            } else {
                                information = parents === "maternal"? InformationCarrierMaternal.A: InformationCarrierPatrenal.A
                                return 2
                            }
                        }
                    }
                }
            }
        } else {
            information = parents === "maternal"? InformationCarrierMaternal.A: InformationCarrierPatrenal.A
            if (directDetection){
                if (allele2Up && allele2Down) {
                    if (upNonCarAux !== 0 && downNonCarAux !== 0 && upCarAux >= 6 && downCarAux >= 6){
                        information = parents === "maternal"? InformationCarrierMaternal.I: InformationCarrierPatrenal.I
                        return 5
                    } else {
                        information = parents === "maternal"? InformationCarrierMaternal.B: InformationCarrierPatrenal.B
                        return 3 
                    }
                }
                else if (allele2Up|| allele2Down) return 2
                else return 1
            } else {
                if (allele2Up && allele2Down) return 2
                else if (allele2Up|| allele2Down) return 1
                else return 0
            }
        }
        return 0
    }

    const calculateAfected = () => {
       const a1UpAux: number = aboveGeneA1 
       const a1DownAux: number = belowGeneA1 
       const a2UpAux: number = aboveGeneA2 
       const a2DownAux: number = belowGeneA2 

       allele1Up = a1UpAux >= 3
       allele1Down = a1DownAux >= 3
       allele2Up = a2UpAux >= 3
       allele2Down = a2DownAux>= 3

       if (directDetection || directDetection2) {
        if (directDetection && directDetection2){
            if (allele1Up || allele1Down) {
                if (allele1Up && allele1Down){
                    if (allele2Up || allele2Down){
                        if (allele2Up && allele2Down){
                            information = parents === "maternal"? InformationAffectedMaternal.L : InformationAffectedPaternal.L
                            return 8
                        } else {
                            information = parents === "maternal"? InformationAffectedMaternal.F : InformationAffectedPaternal.F
                            return 6
                        }
                    } else {
                        information = parents === "maternal"? InformationAffectedMaternal.M : InformationAffectedPaternal.M
                        return 4
                    }
                } else {
                    if (allele2Up || allele2Down){
                       if (allele2Up && allele2Down){
                            information = parents === "maternal"? InformationAffectedMaternal.E : InformationAffectedPaternal.E
                            return 6
                       } else {
                            if ((allele1Up && allele2Up) || (allele1Down && allele2Down )){
                                information = parents === "maternal"? InformationAffectedMaternal.P : InformationAffectedPaternal.P
                            } else if ((allele1Up && allele2Down) || (allele1Down && allele2Up)){
                                information = parents === "maternal"? InformationAffectedMaternal.J : InformationAffectedPaternal.J
                            }
                            return 4
                       }
                    } else {
                        information = parents === "maternal"? InformationAffectedMaternal.A : InformationAffectedPaternal.A
                        return 3
                    }
                }
            } else {
                if (allele2Up || allele2Down) {
                    if (allele2Up && allele2Down){
                        information = parents === "maternal"? InformationAffectedMaternal.N : InformationAffectedPaternal.N
                        return 4
                    } else {
                        information = parents === "maternal"? InformationAffectedMaternal.A : InformationAffectedPaternal.A
                        return 3
                    }
                } else {
                    information = parents === "maternal"? InformationAffectedMaternal.A : InformationAffectedPaternal.A
                    return 1
                }
            }
        } else {
            if (directDetection2){
                if(allele1Up || allele1Down){
                    if(allele1Up && allele1Down){
                        if (allele2Up || allele2Down){
                            if (allele2Up && allele2Down){
                                information = parents === "maternal"? InformationAffectedMaternal.K : InformationAffectedPaternal.K
                                return 7
                            } else {
                                information = parents === "maternal"? InformationAffectedMaternal.F : InformationAffectedPaternal.F
                                return 6
                            }
                        } else {
                            information = parents === "maternal"? InformationAffectedMaternal.M : InformationAffectedPaternal.M
                            return 5
                        }
                    } else {
                        if (allele2Up || allele2Down){
                            if (allele2Up && allele2Down){
                                information = parents === "maternal"? InformationAffectedMaternal.C : InformationAffectedPaternal.C
                                return 5
                            } else {
                                if ((allele1Down && allele2Down) || (allele1Up && allele2Up)){
                                    information = parents === "maternal"? InformationAffectedMaternal.O : InformationAffectedPaternal.O
                                } else if((allele1Down && allele2Up) || (allele1Up || allele2Down)){
                                    information = parents === "maternal"? InformationAffectedMaternal.I : InformationAffectedPaternal.I
                                }
                                return 4
                            }
                        } else {
                            information = parents === "maternal"? InformationAffectedMaternal.A : InformationAffectedPaternal.A
                            return 3
                        }
                    }
                } else {
                    if (allele2Up || allele2Down){
                        if (allele2Up && allele2Down){
                            information = parents === "maternal"? InformationAffectedMaternal.H : InformationAffectedPaternal.H
                            return 3
                        } else {
                            information = parents === "maternal"? InformationAffectedMaternal.A : InformationAffectedPaternal.A
                            return 2
                        }
                    } else {
                        information = parents === "maternal"? InformationAffectedMaternal.A : InformationAffectedPaternal.A
                        return 0
                    }
                }
            } else {
                if(allele1Up || allele1Down){
                    if(allele1Up && allele1Down){
                        if (allele2Up || allele2Down){
                            if (allele2Up && allele2Down){
                                information = parents === "maternal"? InformationAffectedMaternal.K : InformationAffectedPaternal.K
                                return 7
                            } else {
                                information = parents === "maternal"? InformationAffectedMaternal.D : InformationAffectedPaternal.D
                                return 5
                            }
                        } else {
                            information = parents === "maternal"? InformationAffectedMaternal.H : InformationAffectedPaternal.H
                            return 3
                        }
                    } else {
                        if (allele2Up || allele2Down){
                            if (allele2Up && allele2Down){
                                information = parents === "maternal"? InformationAffectedMaternal.E : InformationAffectedPaternal.E
                                return 6
                            } else {
                                if ((allele1Down && allele2Down) || (allele1Up && allele2Up)){
                                    information = parents === "maternal"? InformationAffectedMaternal.O : InformationAffectedPaternal.O
                                } else if((allele1Down && allele2Up) || (allele1Up || allele2Down)){
                                    information = parents === "maternal"? InformationAffectedMaternal.I : InformationAffectedPaternal.I
                                }
                                return 4
                            }
                        } else {
                            information = parents === "maternal"? InformationAffectedMaternal.A : InformationAffectedPaternal.A
                            return 2
                        }
                    }
                } else {
                    if (allele2Up || allele2Down){
                        if (allele2Up && allele2Down){
                            information = parents === "maternal"? InformationAffectedMaternal.N : InformationAffectedPaternal.N
                            return 5
                        } else {
                            information = parents === "maternal"? InformationAffectedMaternal.A : InformationAffectedPaternal.A
                            return 3
                        }
                    } else {
                        information = parents === "maternal"? InformationAffectedMaternal.A : InformationAffectedPaternal.A
                        return 1
                    }
                }
            }
        }
       } else {
            if (allele1Up || allele1Down) {
                if (allele1Up && allele1Down) {
                    if (allele2Up || allele2Down){
                        if (allele2Up && allele2Down){
                            information = parents === "maternal"? InformationAffectedMaternal.G : InformationAffectedPaternal.G
                            return 7
                        } else {
                            information = parents === "maternal"? InformationAffectedMaternal.D : InformationAffectedPaternal.D
                            return 5
                        }
                    } else {
                        information = parents === "maternal"? InformationAffectedMaternal.H : InformationAffectedPaternal.H
                        return 3
                    }
                } else {
                    if (allele2Up || allele2Down) {
                        if (allele2Up && allele2Down) {
                            information = parents === "maternal"? InformationAffectedMaternal.C : InformationAffectedPaternal.C
                            return 5
                        } else {
                            if ((allele1Down && allele2Up) || (allele1Up && allele2Down)) {
                                information = parents === "maternal"? InformationAffectedMaternal.B : InformationAffectedPaternal.B
                                return 3
                            } else if ((allele1Up && allele2Up ) || (allele1Down && allele2Down)){
                                information = parents === "maternal"? InformationAffectedMaternal.H : InformationAffectedPaternal.H
                                return 3
                            }
                        }
                    } else {
                        information = parents === "maternal"? InformationAffectedMaternal.A : InformationAffectedPaternal.A
                        return 1
                    } 
                }
            } else {
                if (allele2Up || allele2Down) {
                    if (allele2Up && allele2Down) {
                        information = parents === "maternal"? InformationAffectedMaternal.H : InformationAffectedPaternal.H
                        return 3
                    } else {
                        information = parents === "maternal"? InformationAffectedMaternal.A : InformationAffectedPaternal.A
                        return 1
                    }
                } else {
                    information = parents === "maternal"? InformationAffectedMaternal.A : InformationAffectedPaternal.A
                    return 0
                } 
            }
       }
       return 0
    }

        if (finalStatus){
           confidenceNumber = directDetection2 !== null? calculateAfected() : calculatedCarrier()
        }



    return [confidenceNumber,information]

}



type STRStatus = "valid" | "info" | "none";

function strStatus(count: number, infoAmp: number): STRStatus {
    if (count >= 3)   return "valid";
    if (infoAmp >= 6) return "info";
    return "none";
}

export function confidenceLevelEmbryo(
    allele: string,
    up: number,
    down: number,
    upInfoAmp: number,
    downInfoAmp: number,
    directDetection: boolean,
): [number, string] {

    const upStatus   = strStatus(up, upInfoAmp);
    const downStatus = strStatus(down, downInfoAmp);

    const label = (key: keyof typeof InformationEmbryosMaternal): string =>
        allele === "p1"
            ? InformationEmbryosMaternal[key]
            : InformationEmbryosPaternal[key];

    if (!directDetection) {
        if (upStatus === "valid" && downStatus === "valid") return [5, label("G")];
        if (upStatus === "valid" && downStatus === "info")  return [3, label("D")];
        if (upStatus === "info"  && downStatus === "valid") return [3, label("D")];
        if (upStatus === "valid" && downStatus === "none")  return [2, label("C")];
        if (upStatus === "none"  && downStatus === "valid") return [2, label("C")];
        if (upStatus === "info"  && downStatus === "info")  return [2, label("B")];
        if (upStatus === "info"  && downStatus === "none")  return [1, label("B")];
        if (upStatus === "none"  && downStatus === "info")  return [1, label("B")];
        return [0, label("A")]; 
    }

    if (upStatus === "valid" && downStatus === "valid") return [7, label("H")];
    if (upStatus === "valid" && downStatus === "info")  return [5, label("F")];
    if (upStatus === "info"  && downStatus === "valid") return [5, label("F")];
    if (upStatus === "valid" && downStatus === "none")  return [4, label("E")];
    if (upStatus === "none"  && downStatus === "valid") return [4, label("E")];
    if (upStatus === "info"  && downStatus === "info")  return [4, label("I")];
    if (upStatus === "info"  && downStatus === "none")  return [3, label("J")];
    if (upStatus === "none"  && downStatus === "info")  return [3, label("J")];
    return [2, label("B")]; 
}